module.exports = __webpack_public_path__ + "static/caseStudyMobile-747d175a66974d54dfed063d11c21899.png";